// extracted by mini-css-extract-plugin
export default {"container":"Splash_container__5jYb9","loginBtn":"Splash_loginBtn__d9D54","loginHeader":"Splash_loginHeader__WBZA0","colorChange":"Splash_colorChange__Bb+0V"};